<template>
	<promo-sales-timed>
		<template slot-scope="{ phasesInfo: { currentPhase } }">
			<div
				v-if="isVisible(currentPhase)"
				class="promo-flash-banner"
			>
				<div class="container">
					<div class="promo-flash-banner__col-text">
						<h3 class="promo-flash-banner__heading">
							NZXT HOLIDAY CELEBRATION! <br class="hide-desktop"> WE GOT YOU SOMETHING
						</h3>
						<p class="promo-flash-banner__discount">
							<span class="hide-mobile">
								Get an H510 on us with any build. Offer ends 12/31 @11:59pm PST.
							</span>
							<span class="hide-desktop">
								Get an H510 on us with any build.
							</span>
						</p>
					</div>
					<div class="promo-flash-banner__col-cta">
						<a href="https://promo.nzxt.com/holiday-celebration" class="promo-flash-banner__button">
							LEARN MORE
						</a>
					</div>
				</div>
			</div>
		</template>
	</promo-sales-timed>
</template>

<script>
import PromoSalesTimed from "@/components/promo-sales-timed";
import { isMobile } from "@/util/helpers";

export default {
	name: "PromoSale2020FlashBanner",
	components: {
		PromoSalesTimed
	},
	methods: {
		isVisible(currentPhase) {
			const excludedRoutes = [
				"home",
				"step4",
				"step5"
			];
			const excludedMobileRoutes = [
				"step1",
				"step2",
				"step3",
				"step4-mobile"
			];
			return currentPhase >= 0 && !(isMobile() ? excludedRoutes.concat(excludedMobileRoutes) : excludedRoutes).includes(this.$route.name);
		}
	}
};
</script>

<style lang="scss">
.promo-flash-banner {
	.annual-sales.extra-small {
		justify-content: flex-end;
	}
}
</style>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.promo-flash-banner {
	height: 80px;
	display: flex;
	align-items: center;
	color: $oldpurple;
	background-color:#DDCAF0;
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
	background-image: url("/images/promo-sales/christmas-2020/christmas-flash-banner-bg.jpg");

	@media (max-width: 767px) {
		background-image: url("/images/promo-sales/christmas-2020/christmas-flash-banner-bg-mobile.jpg");
	}

	.container {
		display: flex;
		align-items: center;

		@media (max-width: 991px) {
			width: 100%;
		}

		@media (max-width: 500px) {
			padding-right: 10px;
			padding-left: 10px;
		}
	}

	&__col-cta {
		display: flex;
		align-items: center;
		margin-left: auto;
	}

	&__heading {
		font-size: 16px;
		font-weight: bold;
		letter-spacing: 1px;
		margin: 0;

		@media (max-width: 500px) {
			font-size: 14px;
			letter-spacing: 0.7px;
			line-height: 18px;
		}
	}

	&__discount {
		color: #851FB1;
		font-size: 12px;
		letter-spacing: 0.75px;
		margin: 0;
	}

	&__button {
		background: $oldpurple;
		border: solid 2px $oldpurple;
		color: #FFF;
		margin-left: 10px;
		font-size: 11px;
		letter-spacing: 0;
		border-radius: 2px;
		text-transform: uppercase;
		padding: 10px 20px;
		transition: all 0.3s;
		text-align: center;

		&:hover {
			background: transparent;
			color: $oldpurple;
		}

		@media (max-width: 500px) {
			padding: 10px 0;
			width: 95px;
		}
	}

	.hide-mobile {
		@media (max-width: 767px) {
			display: none;
		}
	}

	.hide-desktop {
		display: none;

		@media (max-width: 767px) {
			display: block;
		}
	}
}

</style>
